<template>
    <div class="toolsHome">
        <menus class="menu" title="Tools"></menus>
        <div class="tools">
            <router-link to="/tools/passwordGenerator">
                <sbuttion class="toosItem">
                    <svg
                        id="图层_1"
                        data-name="图层 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 -8 66 90"
                        width="128"
                        height="128"
                    >
                        <title>a</title>
                        <path
                            d="M43,52V45a21,21,0,0,1,42,0v7h1A11,11,0,0,1,97,63V93a11,11,0,0,1-11,11H42A11,11,0,0,1,31,93V63A11,11,0,0,1,42,52Zm6,0H79V45a15,15,0,0,0-30,0ZM37,63V93a5,5,0,0,0,5,5H86a5,5,0,0,0,5-5h0V63a5,5,0,0,0-5-5H42a5,5,0,0,0-5,5Z"
                            transform="translate(-31 -24)"
                        />
                        <path
                            d="M43.91,62.11h5.17c2.65,0,4.46,1.47,4.46,4S51.69,70.2,49,70.2H45.36v6H43.91Zm1.45,6.83H49c2.12,0,3.07-1.08,3.07-2.79a2.67,2.67,0,0,0-3-2.78H45.36Z"
                            transform="translate(-31 -24)"
                        />
                        <path
                            d="M59.17,76.18,55.33,62.11h1.5C57.84,66,59.7,72.93,60,74.57h0c.31-1.54,2.45-8.8,3.41-12.46H64.9c.89,3.3,3,11.06,3.26,12.41h0c.44-2.19,2.62-9.27,3.5-12.41h1.44L68.9,76.18H67.32c-.9-3.28-2.92-10.78-3.2-12.2h0c-.39,2-2.4,8.82-3.36,12.2Z"
                            transform="translate(-31 -24)"
                        />
                        <path
                            d="M75.52,62.11h4.83c3.9,0,6.57,2.69,6.57,6.9s-2.61,7.17-6.61,7.17H75.52ZM77,74.91h3.19c3.54,0,5.25-2.5,5.25-5.85,0-3-1.55-5.69-5.24-5.69H77Z"
                            transform="translate(-31 -24)"
                        />
                        <text x="-31" y="-24" />
                        <path
                            d="M55.88,93.94H54.74a8.91,8.91,0,0,1-.16-2.1c-.55,1-1.71,2.27-4.47,2.27C46.06,94.11,44,91,44,87c0-4.2,2.25-7.37,6.43-7.37,3.14,0,5.17,1.67,5.6,4.23H54.55a4,4,0,0,0-4.2-3c-3.41,0-4.87,2.67-4.87,6,0,3.07,1.44,5.89,4.76,5.89s4.24-2.2,4.24-5v-.16H50.2V86.44h5.68Z"
                            transform="translate(-31 -24)"
                        />
                        <path
                            d="M68,87.17h-7.1v5.49h7.78l-.19,1.28h-9V79.87H68.3v1.27H60.85V85.9H68Z"
                            transform="translate(-31 -24)"
                        />
                        <path
                            d="M71.3,93.94V79.87h2c2.11,3.33,6.92,10.8,7.76,12.33h0C81,90.27,81,88.14,81,85.84v-6h1.41V93.94H80.51c-2-3.17-6.92-11.06-7.87-12.62h0c.1,1.74.09,3.94.09,6.49v6.13Z"
                            transform="translate(-31 -24)"
                        />
                    </svg>
                    <br />密码生成器
                </sbuttion>
            </router-link>
        </div>
    </div>
</template>

<script>
import sbuttion from '@/components/sbutton.vue'
import menus from '@/components/menus.vue'
export default {
    components: {
        sbuttion,
        menus,
    }
}
</script>

<style>
.menu {
}
.toolsHome {
    height: 100%;
}
.tools {
    max-width: 960px;
    height: 60%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.toosItem {
    width: 130px;
    height: 160px;
    margin: 0px auto;
}
</style>